export default {
    sfje: {
        linshi: 1232.22,
        yuezu: 2343.54,
        zonge: 1232.22 + 2343.54
    },
    rctj: {
        linshiruchang: 123,
        yuezuruchange: 100,
        linshichuchang: 120,
        yuezuchuchang: 84,
        whiteruchang: 84,
        whitechuchang: 84,

    },
    zcsl: {
        linshi: 23,
        yuezu: 36,
        zongchewei: 400
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/loadBlockInfo.js